<template>
    <div class="parent-height">
        <header class="header">
            <div class="header__in">
                <div class="logo">
                    <router-link :to="{name:'project-default'}" title="Přejít na seznam projektů">
                        <img src="/assets/images/layout/domovio-logo.svg" class="logo__image"
                             alt="logo domovio">
                    </router-link>
                </div>

                <div class="user-panel" v-if="me && isLoggedIn">
                    <button @click="logout" class="user-panel__logout" title="Odhlásit se">
                        Odhlásit se
                    </button>
                </div>
            </div>
        </header>
        <slot/>
    </div>
</template>
<script>
export default {
    computed: {
        me() {
            return this.$store.getters['user/me'];
        },
        isLoggedIn() {
            return this.$store.getters['user/isLoggedIn'];
        }
    },
    methods:  {
        logout() {
            this.$store.dispatch('user/logout')
                .catch((message) => this.$dmv.notifyError(message))
                .finally(() => window.location.href = this.$dmv.env.APP_DOMAIN);
        }
    }
}
</script>
